import './App.css';
import './index.css';
import './DatePicker.css';
import './Calendar.css';
import { BrowserRouter as Router, Route, Switch, useLocation } from "react-router-dom";
import { Login } from './component/Login';
import { AppDownload } from './component/AppDownload';
import { MemberCard } from './component/MemberCard';
import { Home } from './component/Home';
import { FreeSignUp } from './component/Signup/FreeSignUp';
import { Points } from './component/Points';
import { Renew } from './component/Renew';
import { ReferFriend } from './component/ReferFriend';
import { SubscriptionsPage } from './component/SubscriptionsPage';
import { PersonalDetailsPage } from './component/PersonalDetailsPage';
import { OAuthLogin } from './component/Authentication/OAuthLogin';
import { RedirectPage } from './component/Redirect/RedirectPage';
import { ProtectedRoute } from './component/protected.route';
import { VisitorSignUp } from './component/VisitorSignUp';
import { SportingClubRegistration } from './component/SportingClubRegistration';
import React from 'react';

export default function App() {
  function useQuery() {
    const { search } = useLocation();
  
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  let query = useQuery();

    return (
      <Router>
        <div className="App">
          <Switch>
          <Route exact path="/redirect/:code" component={RedirectPage} />
          <Route exact path="/oauth" component={OAuthLogin} />
          <Route exact path="/signup" component={FreeSignUp} />
          <Route exact path="/app" component={AppDownload} />
          <Route exact path="/card" component={MemberCard} />
          <Route exact path="/dayslipSignUp" component={() => <VisitorSignUp entry={query.get('entry')} venue={query.get('venue')} />}/>
          <Route exact path="/visitorSignUp" component={() => <VisitorSignUp entry={query.get('entry')} venue={query.get('venue')} />}/>
          {/* format looks funny below, but it has to be like that to be able to support query params  */}
          <Route exact path="/sportingClub" component={() => <SportingClubRegistration clubID={query.get('clubID')} />}/>
          <Route exact path="/sportingClubRegistration" component={() => <SportingClubRegistration clubID={query.get('clubID')} />}/>
          <ProtectedRoute exact path="/home" component={Home}/>
          <ProtectedRoute exact path="/points" component={Points} />
          <ProtectedRoute exact path="/renew" component={Renew} />
          <ProtectedRoute exact path="/details" component={PersonalDetailsPage} />
          <ProtectedRoute exact path="/subscriptions" component={SubscriptionsPage} />
          <ProtectedRoute exact path="/referFriend" component={ReferFriend} />
          <Route exact path="/visitorSignUp" component={Login} />

          <Route exact path='/' component={Login} />
          </Switch>
        </div>
      </Router>
    );
  
}
